// extracted by mini-css-extract-plugin
export default {"main":"Main_main__oqlls","head":"Main_head__ccITK","title":"Main_title__TDw7q","breadcrumbs":"Main_breadcrumbs__0XXdc"};